module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/spice-market@3x_d00ee3.jpg";